var imgStorie = document.querySelectorAll('.stories ul li img');
for (var i = 0; i < imgStorie.length; i++) {
  (function(index) {
    imgStorie[index].addEventListener('click', function(event) {
      document.querySelector('.modal-reel-' + (index + 1)).classList.add("active");
      var video = document.querySelector('.modal-reel-' + (index + 1) + ' video');

      video.play();

      const modalReel = document.querySelector('.modal-reel-' + (index + 1));
      modalReel.addEventListener('mousemove', function(event) {
          if (!event.target.closest('video')) {
            if ( document.querySelector('mouse-cursor').classList.contains("active") === false ){
              document.querySelector('mouse-cursor').classList.add("active");
            }
          }else{
            if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
              document.querySelector('mouse-cursor').classList.remove("active");
            }
          }
      });

      modalReel.onclick = function() {
        if (!event.target.closest('video')) {
          video.pause();
          document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
          if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
            document.querySelector('mouse-cursor').classList.remove("active");
          }
        }
      };

      video.addEventListener('ended', () => {
        document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
        if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
          document.querySelector('mouse-cursor').classList.remove("active");
        }
      });
      
    });
  })(i);
}


function playAudio(audioId) {
  const audios = document.querySelectorAll('audio');

  audios.forEach(audio => {
    if (!audio.paused && audio.id !== audioId) {
      audio.pause();
      audio.parentElement.querySelector('svg[class*="play-extrait"]').style.cssText = "display: block;";
      audio.parentElement.querySelector('svg[class*="pause-extrait"]').style.cssText = "display: none;";
    }
  });

  document.getElementById(audioId).play();
}


if (!!document.querySelector(".product__info .product__rating") === true){
  document.querySelector(".product__info .product__rating").onclick = function() {
    var topReviews = document.querySelector(".shopify-section.app-section:has(.jdgm-carousel-wrapper)").offsetTop;
    window.scrollTo({top: (topReviews - 100),behavior: 'smooth'});
  };
}


document.addEventListener("DOMContentLoaded", function() {
  if (!!document.querySelector(".en-savoir-plus") === true){
    var width_screen = window.innerWidth;
    
    document.querySelector(".en-savoir-plus").onclick = function() {
      if (!!document.querySelector(".second-product_info") === true){
        var element = document.querySelector(".second-product_info");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop - 40;
        }else{
          var topDesc = element.offsetTop;
        }
      }else{
        var element = document.querySelector("#description-redirection");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop + 300;
        }else{
          var topDesc = element.offsetTop + 10;
        }
      }
      window.scrollTo({top: (topDesc + 60),behavior: 'smooth'});
    };
  }
});

document.addEventListener('DOMContentLoaded', function() {
  customElements.whenDefined('scroll-shadow').then(() => {
    const scrollShadow = document.querySelector('scroll-shadow');
    
    if (scrollShadow){
      // Supprimer seulement le template qui contient les flèches
      const template = scrollShadow.querySelector('template');
      if (template) {
        template.remove();
      }

      // Alternative : vider le shadow-root tout en gardant la structure
      if (scrollShadow.shadowRoot) {
        const slot = document.createElement('slot');
        scrollShadow.shadowRoot.innerHTML = '';
        scrollShadow.shadowRoot.appendChild(slot);
      }
    }
  });

  // Section video - Enlever le bouton Play quand on clique dessus
  var video_play_btn = document.querySelectorAll('.shopify-section[id*="video_with_text"] video-media button');
  for (var i = 0; i < video_play_btn.length; i++) {
    video_play_btn[i].addEventListener('click', function(event) {
      event.currentTarget.style.cssText = "display: none;";
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  
  function gestionCoffretCadeau() {
    
    const coffretDataElement = document.getElementById('coffret-size-data');
    if (!coffretDataElement) return;
    
    const coffretData = JSON.parse(coffretDataElement.textContent);
    const COFFRET_PRODUCT_ID = 15020763578691;
    const COFFRET_HANDLE = "le-pack-cadeau-jewkids";
    
    let isUpdatingCoffret = false;
    let coffretDesactive = false;
    let analyseTimer = null;
    
    function toggleDrawerInteractions(disable) {
      const drawerInner = document.querySelector('#CartDrawer');
      const checkoutButton = document.querySelector('.drawer__footer-buttons>.button--primary');
      
      if (drawerInner) {
        drawerInner.style.pointerEvents = disable ? 'none' : '';
      }
      
      if (checkoutButton) {
        if (disable) {
          checkoutButton.setAttribute('aria-busy', 'true');
          checkoutButton.setAttribute('aria-disabled', 'true');
        } else {
          checkoutButton.removeAttribute('aria-busy');
          checkoutButton.removeAttribute('aria-disabled');
        }
      }
    }
    
    function determineCoffretSize(speakers, figurines, accessoires) {
      let size = '';
      
      if (speakers === 0) {
        if (figurines >= 1 && figurines <= 2) size = 'XS';
        else if (figurines >= 3 && figurines <= 4) size = 'S';
        else if (figurines >= 5 && figurines <= 8) size = 'M';
        else if (figurines >= 9 && figurines <= 12) size = 'L';
      } else if (speakers === 1) {
        if (figurines === 0) size = 'BOX';
        else if (figurines === 1) size = 'XS';
        else if (figurines >= 2 && figurines <= 3) size = 'S';
        else if (figurines >= 4 && figurines <= 5) size = 'M';
        else if (figurines >= 6 && figurines <= 7) size = 'L';
      } else if (speakers === 2) {
        if (figurines === 0) size = 'XS';
        else if (figurines === 1) size = 'S';
        else if (figurines >= 2 && figurines <= 3) size = 'M';
        else if (figurines >= 4 && figurines <= 6) size = 'L';
      } else if (speakers >= 3) {
        size = 'L';
      }
      
      if (size !== '' && accessoires > 0) {
        const sizeOrder = ['BOX', 'XS', 'S', 'M', 'L'];
        let currentIndex = sizeOrder.indexOf(size);
        let cransToAdd = Math.min(accessoires, 2);
        let newIndex = Math.min(currentIndex + cransToAdd, sizeOrder.length - 1);
        size = sizeOrder[newIndex];
      }
      
      return size;
    }
    
    function construireNote(taille, noteActuelle) {
      const regex = /\d+x Carton\s*–\s*Taille \w+/g;
      let note = (noteActuelle || '').replace(regex, '').trim();
      
      if (taille) {
        const ligneCarton = `1x Carton – Taille ${taille}`;
        note = note ? `${note}\n${ligneCarton}` : ligneCarton;
      }
      
      return note;
    }
    
    function getSectionsToRender() {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      return sectionsToBundle.length > 0 ? sectionsToBundle : ['cart-drawer', 'cart-icon-bubble'];
    }
    
    function rafraichirPanier(sections) {
      return fetch(`${theme.routes.cart_url}.js`)
        .then(r => r.json())
        .then(cartJson => {
          if (sections) {
            cartJson['sections'] = sections;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
            cart: cartJson, 
            line: 1, 
            name: 'update' 
          });
        });
    }
    
    function cartUpdate(updates, note) {
      const sections = getSectionsToRender();
      const body = { updates, sections };
      if (note !== undefined) body.note = note;
      
      return fetch(`${theme.routes.cart_update_url}`, {
        ...theme.utils.fetchConfig(),
        body: JSON.stringify(body)
      })
        .then(r => r.json())
        .then(parsedState => {
          rafraichirPanier(parsedState.sections);
          return parsedState;
        });
    }
    
    function cartAdd(variantId, quantity, message) {
      const sections = getSectionsToRender();
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity.toString());
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      
      if (message) {
        formData.append('properties[Message]', message);
      }
      
      const config = theme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      
      return fetch(`${theme.routes.cart_add_url}`, config)
        .then(r => r.json())
        .then(parsedState => {
          rafraichirPanier(parsedState.sections);
          return parsedState;
        });
    }
    
    function planifierAnalyse(delai = 500) {
      if (analyseTimer) clearTimeout(analyseTimer);
      analyseTimer = setTimeout(() => {
        analyseTimer = null;
        if (!coffretDesactive && !isUpdatingCoffret) {
          analyseEtMiseAJourCoffret();
        }
      }, delai);
    }
    
    function analyseEtMiseAJourCoffret(forcerReactivation = false) {
      
      if (coffretDesactive && !forcerReactivation) return;
      if (forcerReactivation) coffretDesactive = false;
      if (isUpdatingCoffret) return;
      
      isUpdatingCoffret = true;
      toggleDrawerInteractions(true);
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          
          if (coffretDesactive) {
            isUpdatingCoffret = false;
            toggleDrawerInteractions(false);
            return;
          }
          
          let speakersCount = 0;
          let figurinesCount = 0;
          let accessoiresCount = 0;
          let coffretsExistants = [];
          let messageExistant = null;
          let coffretQuantiteTotal = 0;
          
          cart.items.forEach((item, index) => {
            if (item.product_id === COFFRET_PRODUCT_ID || item.handle === COFFRET_HANDLE) {
              coffretsExistants.push({ ...item, line: index + 1 });
              coffretQuantiteTotal += item.quantity;
              if (!messageExistant && item.properties && item.properties.Message) {
                messageExistant = item.properties.Message;
              }
            }
            else if (item.handle === "coffret-decouverte") {
              speakersCount += item.quantity;
              figurinesCount += item.quantity;
            }
            else if (coffretData.speakers.includes(item.product_id)) {
              speakersCount += item.quantity;
            }
            else if (coffretData.figurines.includes(item.product_id)) {
              figurinesCount += item.quantity;
            }
            else if (coffretData.accessoires.includes(item.product_id)) {
              accessoiresCount += item.quantity;
            }
          });
          
          const tailleNecessaire = determineCoffretSize(speakersCount, figurinesCount, accessoiresCount);
          const noteCalculee = construireNote(tailleNecessaire || null, cart.note);
          
          // 1. No coffret needed but exists → remove all
          if (!tailleNecessaire && coffretsExistants.length > 0) {
            const updates = {};
            coffretsExistants.forEach(c => { updates[c.key] = 0; });
            
            cartUpdate(updates, noteCalculee)
              .finally(() => {
                setTimeout(() => {
                  isUpdatingCoffret = false;
                  toggleDrawerInteractions(false);
                }, 1000);
              });
            return;
          }
          
          // 2. No coffret needed and doesn't exist → just update note
          if (!tailleNecessaire || !coffretData.sizes[tailleNecessaire]) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteCalculee })
            }).finally(() => {
              isUpdatingCoffret = false;
              toggleDrawerInteractions(false);
            });
            return;
          }
          
          const variantIdNecessaire = coffretData.sizes[tailleNecessaire];
          
          // 3. Coffret(s) exist(s)
          if (coffretsExistants.length > 0) {
            
            const coffretBonVariant = coffretsExistants.find(c => c.variant_id === variantIdNecessaire);
            const coffretsMauvaisVariant = coffretsExistants.filter(c => c.variant_id !== variantIdNecessaire);
            
            if (coffretsExistants.length === 1 && coffretBonVariant) {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: noteCalculee })
              }).finally(() => {
                isUpdatingCoffret = false;
                toggleDrawerInteractions(false);
              });
              return;
            }
            
            const updates = {};
            coffretsMauvaisVariant.forEach(c => { updates[c.key] = 0; });
            
            if (coffretBonVariant) {
              updates[coffretBonVariant.key] = coffretQuantiteTotal;
              coffretsExistants.filter(c => c.variant_id === variantIdNecessaire && c.key !== coffretBonVariant.key).forEach(c => {
                updates[c.key] = 0;
              });
              
              cartUpdate(updates, noteCalculee)
                .finally(() => {
                  setTimeout(() => {
                    isUpdatingCoffret = false;
                    toggleDrawerInteractions(false);
                  }, 1000);
                });
            } else {
              cartUpdate(updates, noteCalculee)
                .then(() => cartAdd(variantIdNecessaire, coffretQuantiteTotal, messageExistant))
                .finally(() => {
                  setTimeout(() => {
                    isUpdatingCoffret = false;
                    toggleDrawerInteractions(false);
                  }, 1500);
                });
            }
            
          } else {
            // 4. Coffret doesn't exist → just update note
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteCalculee })
            }).finally(() => {
              isUpdatingCoffret = false;
              toggleDrawerInteractions(false);
            });
            return;
          }
        })
        .catch(() => {
          isUpdatingCoffret = false;
          toggleDrawerInteractions(false);
        });
    }
    
    // Events
    document.addEventListener('cart:updated', function() {
      if (!coffretDesactive && !isUpdatingCoffret) {
        planifierAnalyse(800);
      }
    });
    
    document.addEventListener('ajaxProduct:added', function(evt) {
      const detail = evt.detail || {};
      const productId = detail.product_id || detail.productId;
      const handle = detail.handle || '';
      
      if (coffretDesactive) {
        if (productId && (
          coffretData.speakers.includes(productId) || 
          coffretData.figurines.includes(productId) || 
          coffretData.accessoires.includes(productId)
        )) {
          coffretDesactive = false;
        }
      }
      
      if (!coffretDesactive) {
        const delai = (productId === COFFRET_PRODUCT_ID || handle === COFFRET_HANDLE) ? 2000 : 800;
        planifierAnalyse(delai);
      }
    });
    
    document.addEventListener('page:loaded', function() {
      planifierAnalyse(300);
    });
    
    planifierAnalyse(300);
  }
  
  gestionCoffretCadeau();
});


document.addEventListener("DOMContentLoaded", function() {
  if ( !!document.querySelector(".pack-figurines") === false && !!document.querySelector(".variant-picker:not(.variant-picker-coffret)") === true ){
    var variant_pickers = document.querySelectorAll(".variant-picker:not(.variant-picker-coffret) label");
    for (var i = 0; i < variant_pickers.length; i++) {
      variant_pickers[i].addEventListener('click', function(event) {
        setTimeout(function () {
          var regular_price = document.querySelector(".product__info .product__price .price__regular").textContent;
          document.querySelector('form.product-form .product-form__submit .btn-text .normal-price-atc').setAttribute("data-after", regular_price);
          var price_sale = document.querySelector('.product__info .product__price .price__sale');
          if (price_sale){
            document.querySelector('form.product-form .product-form__submit .btn-text .compare-price-atc').setAttribute("data-after", price_sale.textContent);
          }else{
            document.querySelector('form.product-form .product-form__submit .btn-text .compare-price-atc').setAttribute("data-after", "");
          }
        }, 500);
      });
    }
  }
});